/* eslint-disable */
"use strict";

var __bucketName = 'kv3';

module.exports = {
  AmazonS3: {
    bucketName: __bucketName,
    root: "https://s3.amazonaws.com/" + __bucketName + "/"
  },
  appRootNode: '.main-wrapper',
  layerSize: function () {
    return "1620x1080";
  },

  /**
   * Returns a hardcoded feature description, this will be removed later
   * @param featureName
   */
  featureDescription: function (featureName) {
    switch ((featureName || '').toLowerCase()) {
      case 'material':
        return "How many square feet of material do you need for your project? If you need help calculating, press the square foot calculator button.";
      case "room":
        return "Please select the room in which you would like new countertops.";
      case "edge profile":
        return "The edge profile of the countertop is a small detail among many in the kitchen. The shape of your countertop's edge can have a huge effect on function, impacting everything from cleaning to safety.";
      case "cutouts":
        return "Select the Cutouts you will need for your new countertops.";
      case "faucets":
      case "faucet":
        return "Do you need a faucet for your countertop project? If so, select the faucet that you would like to use for your countertops.";
      case "sinks":
      case "sink":
        return "Do you need a sink for your countertop project? If so, select the sink that you would like to use for your countertops.";
      case "counter top removal":
        return "Professional removal and disposal of your existing countertop material.";
      case "radius":
        return "Radius corners refer to the degree of “roundness” the countertop corners will have “Soft” corners are the corners that are exposed to traffic areas or where people walk.";
      case "plumbing":
        return "If you would like the plumbing work done by our team please select an option.";
      case "backsplash":
        return "Select a Backsplash option for your job.";
      case "sealer":
        return "Natural Stone requires some special considerations, but simple care and maintenance will keep your Natural Stone Countertops looking beautiful.";
      case "hourly labor":
        return "Hourly labor may be charged for work that needs to be done that may not be part of a standard installation or fabrication job.";
      case "trip charge":
        return "For service outside of our normal service range we may charge a trip charge to compensate for time and fuel.";
      case "milling down":
        return "Does your job require milling down of materials?  If so please enter the square footage below.";
      case "template":
        return "Please choose a template option below.";
      default:
        return featureName + " - N/A";
    }
  }

};


